var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1249"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1249"
    },
    "bundlingPackage": "billing-portal-ui",
    "bundlingPackageVersion": "static-1.2101",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};